export const pricing = {
  title: 'Platinum Plan discount for Clio users',
  subtitle:
    'Choose Clio Platinum.<br /><br />We have a plan for everyone.<br />Choose a plan in order to continue.<br /><hr />',
}; 